import ObjectNumber from '../../../types/Initial/Number/Number';

const validateNumber = (
	value: number | string,
	initialValue: ObjectNumber
): number => {
	if (isNaN(+value)) {
		if (initialValue.onParsedError) {
			const newValue = initialValue.onParsedError(value as string);
			if (isNaN(newValue) || typeof newValue !== 'number')
				throw new Error(
					`onParsedError for type 'number' must returns number, but return '${newValue}'`
				);
			return newValue;
		} else {
			return initialValue.initial;
		}
	}

	return +value;
};

export default validateNumber;
